var map = {
	"./active.svg": 6681,
	"./bi_x.svg": 9533,
	"./deactivated.svg": 8358,
	"./discord-v2-svgrepo-com.svg": 546,
	"./ended_status.svg": 6053,
	"./game_process_status.svg": 6955,
	"./hour.svg": 7154,
	"./login/auth-img.svg": 3735,
	"./login/auth0.svg": 7774,
	"./login/firebase.svg": 66,
	"./login/jwt.svg": 3576,
	"./min.svg": 5470,
	"./not_active.svg": 2069,
	"./not_started_status.svg": 8068,
	"./ru.svg": 8585,
	"./sec.svg": 6702,
	"./svg-icon/1.svg": 2731,
	"./svg-icon/2.svg": 6222,
	"./svg-icon/3.svg": 7481,
	"./svg-icon/4.svg": 685,
	"./svg-icon/5.svg": 4877,
	"./svg-icon/6.svg": 1114,
	"./usa.svg": 9938,
	"./uz.svg": 6398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;